import './wdyr';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Suppress findDOMNode deprecation warning from third-party libraries
const originalWarn = console.warn;
console.warn = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('findDOMNode is deprecated')) {
    return;
  }
  originalWarn.apply(console, args);
};

import '@salvapp/ui-components/build/index.css';
import './assets/css/theme.scss';
import './assets/fonts/feather/feather.min.css';
import './assets/css/common.scss';
import '@fortawesome/fontawesome-svg-core/styles.css';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider } from 'react-redux';
import store from './store/store';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { config } from '@fortawesome/fontawesome-svg-core';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './store/queryClient';

// stops injecting styles to head tag which caused a CSP violation for strict style directive
config.autoAddCss = false;

const container = document.getElementById('root');
const root = createRoot(container!);

const AppRouter = createBrowserRouter([{ path: '*', Component: App }]);

root.render(
  <DndProvider backend={HTML5Backend}>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={AppRouter} />
      </QueryClientProvider>
    </Provider>
  </DndProvider>
);
